import { render, staticRenderFns } from "./editor-decision.dialog.vue?vue&type=template&id=45c5002a&scoped=true"
import script from "./editor-decision.dialog.vue?vue&type=script&lang=js"
export * from "./editor-decision.dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c5002a",
  null
  
)

export default component.exports